import { Alert } from '@/global/components/Alert'
import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { useAlteracoesOutletContext } from 'pages/Alteracoes'
import { useParams } from 'react-router-dom'
import TabDiff from './TabDiff'
import TabObjetoAtual from './TabObjetoAtual'

export default function DetalhesAlteracao() {
    const { data } = useAlteracoesOutletContext()
    const { id } = useParams()
    const value = data.find(item => item.id === Number(id))
    if (!value) return null

    return (
        <TabbedDialog.Root
            tabs={[
                {
                    label: 'Diferenças',
                    content: <TabDiff value={value} />,
                    name: 'diff',
                },
                {
                    label: 'Objeto atual',
                    content: <TabObjetoAtual value={value} />,
                    name: 'atual',
                },
            ]}
        >
            <TabbedDialog.Title>Comparar diferenças</TabbedDialog.Title>
            <TabbedDialog.Content dividers>
                <Alert severity="warning" className="select-none mb-4">
                    Os campos podem não estar formatados corretamente.
                </Alert>
            </TabbedDialog.Content>
            <TabbedDialog.Actions>
                <TabbedDialog.Actions.SecondaryButton>
                    Fechar
                </TabbedDialog.Actions.SecondaryButton>
            </TabbedDialog.Actions>
        </TabbedDialog.Root>
    )
}
